/**
 * Generated runtime TestId mirror for frontend/src/pages/SchemaViolations.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SchemaViolationsTestIds = {
  btnBulkAck: "btn-bulk-ack",
  checkboxToggleAll: "checkbox-toggle-all",
  colActions: "col-actions",
  colDetectedAt: "col-detected-at",
  colMessage: "col-message",
  colPolicy: "col-policy",
  colSelect: "col-select",
  colSeverity: "col-severity",
  colStatus: "col-status",
  schemaViolationsList: "schema-violations-list",
  badgeReferenceBroken: (v_id: string) => `badge-reference-broken-${v_id}`,
  badgeReferenceBrokenPrefix: () => "badge-reference-broken-" as TestIdPrefix,
  btnRowAck: (v_id: string) => `btn-row-ack-${v_id}`,
  btnRowAckPrefix: () => "btn-row-ack-" as TestIdPrefix,
  checkboxViolation: (v_id: string) => `checkbox-violation-${v_id}`,
  checkboxViolationPrefix: () => "checkbox-violation-" as TestIdPrefix,
  violationRow: (v_id: string) => `violation-row-${v_id}`,
  violationRowPrefix: () => "violation-row-" as TestIdPrefix,
  violationSubjects: (v_id: string) => `violation-subjects-${v_id}`,
  violationSubjectsPrefix: () => "violation-subjects-" as TestIdPrefix
} as const;
